import { render, staticRenderFns } from "./FirstSection.vue?vue&type=template&id=4ba024bb&scoped=true&"
import script from "./FirstSection.vue?vue&type=script&lang=js&"
export * from "./FirstSection.vue?vue&type=script&lang=js&"
import style0 from "./FirstSection.vue?vue&type=style&index=0&id=4ba024bb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba024bb",
  null
  
)

export default component.exports